export default __webpack_public_path__ + "static/media/05 - Automatic HTML Form Generator.87b5a8fa.png";